import React, { FC, useEffect } from 'react';
import { Wrapper, AddNewType } from './styles';
import { Header, LayoutComponent } from './components';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'common/hooks/redux';
import { resetSecretaryData } from 'applicaiton/store/reducers/Secretaries/SecretariesSlice';
import { setHasUnsavedChanges } from 'applicaiton/store/reducers/DetectChangesSaved/DetectChangesSavedSlice';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const SecretaryUserAdd: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isExpiredSoon, isBlocked } = useSubscription();

  useEffect(() => {
    return () => {
      dispatch(resetSecretaryData());
      dispatch(setHasUnsavedChanges(false));
    };
  }, []);

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <Header />

      <AddNewType>{t('users.adding_new_secretary')}</AddNewType>

      <LayoutComponent />
    </Wrapper>
  );
};

export default SecretaryUserAdd;
